import React from "react";
import { POPOVER_RESTRICTED } from "../../../../common/components/modals/constants";
import { Popover } from "../../../../common/components/modals/Popover";

export function SearchResultsRestrictedCell({
	packageName,
}: {
	packageName: string;
}) {
	return (
		<div className="restricted-cell">
			<Popover
				classes="popover-grey"
				modalId={POPOVER_RESTRICTED}
				toggleClasses="btn--icon btn--restricted"
				offsetValue={{
					mainAxis: 0,
					crossAxis: -4,
				}}
			>
				<p>
					This information is only visible with a subscription for{" "}
					<span className="text-color-primary">
						{packageName} subscription.
					</span>
				</p>
				<a
					href="/account-management/subscription"
					className="btn btn--link"
				>
					Add to Subscription
				</a>
			</Popover>
		</div>
	);
}
